(function initHeaderCartButton() {
  const cartButton = document.getElementById('headerCartButton');
  if (!cartButton) return;

  cartButton.addEventListener('click', (event) => {
    event.preventDefault();
    if (!window.cartTools) return;
    const cartTools = window.cartTools();
    cartTools.showCart = true;
    cartTools.openCheckout = false;
  });
})();

(function initHeaderCartBadge() {
  const badge = document.getElementById('headerCartBadge');
  if (!badge) return;

  const getCartCount = () => {
    try {
      if (!window.cartTools) return 0;
      const cartTools = window.cartTools();
      const cartContent = cartTools.cartContent?.value || cartTools.cartContent || null;
      const edges = cartContent?.lines?.edges || [];
      if (!Array.isArray(edges)) return 0;
      return edges.reduce((sum, edge) => sum + (edge?.node?.quantity || 0), 0);
    } catch (e) {
      return 0;
    }
  };

  const updateBadge = () => {
    const count = getCartCount();
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = 'flex';
    } else {
      badge.textContent = '';
      badge.style.display = 'none';
    }
  };

  updateBadge();
  setInterval(updateBadge, 1000);
})();

(function initHeaderCompareButton() {
  const mountEl = document.getElementById('headerCompareMount');
  if (!mountEl) return;

  const mountApp = () => {
    if (!window.Vue || !window.Pinia || !window.compareStore) return;

    const app = Vue.createApp({
      delimiters: ['#{', '}'],
      setup() {
        const store = window.compareStore();
        const compareCount = Vue.computed(() => (store?.selectedProducts || []).length);
        const openDrawer = () => {
          const isOpen = !!store?.isDrawerOpen;
          store?.setDrawerOpen?.(!isOpen);
        };
        return { compareCount, openDrawer };
      },
    });

    app.use(window.VueAppGlobals.pinia);
    app.mount(mountEl);
  };

  if (window.Vue && window.Pinia) {
    mountApp();
  } else {
    window.addEventListener('vue-ready', mountApp);
  }
})();

(function initHeaderPhoneButton() {
  const phoneMount = document.getElementById('phoneBlock');
  if (!phoneMount) return;

  const mountPhone = () => {
    if (!window.Vue || !window.Pinia || !window.compareStore) return;

    const app = Vue.createApp({
      delimiters: ['#{', '}'],
      setup() {
        const displayPhone = Vue.ref(false);
        const togglePhone = (phoneURL) => {
          displayPhone.value = !displayPhone.value;
          if (window.innerWidth < 769) {
            window.location.href = phoneURL;
          }
        }
        return { displayPhone, togglePhone };
      },
    });

    app.use(window.VueAppGlobals.pinia);
    app.mount(phoneMount);
  };

  if (window.Vue && window.Pinia) {
    mountPhone();
  } else {
    window.addEventListener('vue-ready', mountPhone);
  }
})();

const syncHeaderHeight = () => {
  const headerTop = document.querySelector('.header-top');
  const headerNav = document.getElementById('headerNav');
  const headerSpacer = document.getElementById('headerTopSpacer');
  const headerHeight = headerTop?.offsetHeight || 0;
  const navHeight = headerNav?.offsetHeight || 0;
  document.documentElement.style.setProperty('--header-top-height', `${headerHeight}px`);
  document.documentElement.style.setProperty('--header-nav-height', `${navHeight}px`);
  if (headerSpacer) {
    headerSpacer.style.height = `${headerHeight + navHeight}px`;
  }
};

(function initHeaderHistoryMenus() {
  const menuConfigs = [
    { id: 'desktop', mountEl: document.getElementById('header-history-menu') },
    { id: 'mobile', mountEl: document.getElementById('header-history-menu-mobile') }
  ].filter((config) => config.mountEl);
  if (!menuConfigs.length) return;

  const mountApps = () => {
    if (!window.Vue || !window.Pinia || !window.historyStore) return;

    const store = window.historyStore();
    store.loadItems();

    Vue.watch(() => store.hasHistory, (hasHistory) => {
      // GGcollectionGrid.liquid reads this inline style to detect previously-viewed products
      menuConfigs.forEach(({ mountEl }) => {
        mountEl.style.display = hasHistory ? '' : 'none';
      });
      document.body.classList.toggle('has-mobile-history', hasHistory);
      const headerNav = document.getElementById('headerNav');
      if (headerNav) headerNav.classList.toggle('has-history', hasHistory);
      syncHeaderHeight();
    }, { immediate: true });

    menuConfigs.forEach(({ id, mountEl }) => {
      const app = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
          const isOpen = Vue.computed(() => store.activeMenu === id);
          const visibleCount = Vue.computed(() => store.visibleCounts[id] || 5);
          const visibleHistoryItems = Vue.computed(() => store.historyDisplayItems.slice(0, visibleCount.value));
          const hasMore = Vue.computed(() => visibleCount.value < store.items.length);
          const isFetching = Vue.computed(() => !!store.pendingFetch);
          const loadMoreLabel = Vue.computed(() => isFetching.value ? 'Loading...' : `Load more (${store.items.length - visibleCount.value})`);
          const listEl = Vue.ref(null);

          const toggle = () => store.toggleMenu(id);

          const loadMore = async () => {
            const prevCount = visibleHistoryItems.value.length;
            await store.loadMoreHistory(id);
            Vue.nextTick(() => {
              const firstNewItem = listEl.value?.children[prevCount];
              if (firstNewItem) firstNewItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            });
          };

          return { store, isOpen, visibleHistoryItems, hasMore, isFetching, loadMoreLabel, listEl, toggle, loadMore };
        }
      });
      app.use(window.VueAppGlobals.pinia);
      app.mount(mountEl);
    });

    if (!document.body.dataset.historyMenusBound) {
      document.body.dataset.historyMenusBound = '1';
      document.addEventListener('click', (e) => {
        if (!store.activeMenu) return;
        const stillInside = menuConfigs.some(({ mountEl }) => mountEl.contains(e.target));
        if (!stillInside) store.activeMenu = null;
      });
    }
  };

  if (window.Vue && window.Pinia) {
    mountApps();
  } else {
    window.addEventListener('vue-ready', mountApps);
  }
})();

document.addEventListener('DOMContentLoaded', function () {

  const headerHamburger = document.getElementById('headerHamburger');
  const headerNav = document.getElementById('headerNav');
  const navMenu = document.getElementById('navMenu');
  const navHamburger = document.getElementById('navHamburger');
  const vehicleSelect = document.getElementById('vehicle-select');
  const wrapper = vehicleSelect ? vehicleSelect.closest('.vehicle-dropdown-wrapper') : null;
  const mobileDropdownToggle = document.getElementById('mobileDropdownToggle');
  const vehicleFitmentRow = document.getElementById('vehicleFitmentRow');

  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);

  const stickyHeader = document.getElementById('stickyHeader');
  let lastScrollY = window.scrollY;
  const isSelectorDropdownOpen = () => {
    return !!document.querySelector(
      '#GGvehicleDropdown .vehicle-dropdown-container, #GGfitmentDropdown .fitment-dropdown-container, #GGvehicleDropdown #vehicleModal'
    );
  };
  const syncBodyHeaderState = () => {
    document.body.classList.toggle('gg-header-collapsed', stickyHeader ? stickyHeader.classList.contains('header-collapsed') : false);
  };
  if (stickyHeader) {
    window.addEventListener('scroll', function () {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 50) {
        stickyHeader.classList.add('scrolled');
      } else {
        stickyHeader.classList.remove('scrolled');
      }

      if(document.getElementById('accordion')) {
        stickyHeader.classList.remove('header-collapsed');
        document.body.classList.remove('header-collapsed');
        syncBodyHeaderState();
        lastScrollY = currentScrollY;
        return;
      }

      if (isSelectorDropdownOpen()) {
        stickyHeader.classList.remove('header-collapsed');
        syncBodyHeaderState();
        lastScrollY = currentScrollY;
        return;
      }

      if (currentScrollY > lastScrollY && currentScrollY > 80) {
        stickyHeader.classList.add('header-collapsed');
      } else {
        stickyHeader.classList.remove('header-collapsed');
      }
      syncBodyHeaderState();
      lastScrollY = currentScrollY;
    });
    syncBodyHeaderState();
  }

  if (headerHamburger && headerNav) {
    headerHamburger.addEventListener('click', function (e) {
      e.preventDefault();
      headerNav.classList.toggle('active');
      navMenu.classList.toggle('active');
      document.body.classList.toggle('dropdown-open', headerNav.classList.contains('active'));
      headerHamburger.classList.toggle('is-open', headerNav.classList.contains('active'));
      if (navHamburger) {
        navHamburger.classList.toggle('is-open', headerNav.classList.contains('active'));
      }
      syncHeaderHeight();
    });
  }

  const updateVehicleState = () => {
    const hasVehicle = !!localStorage.getItem('activeVehicleId');
    if (stickyHeader) {
      stickyHeader.classList.toggle('no-vehicle', !hasVehicle);
    }
  };

  function updateFitmentVisibility() {
    const vehicleFitmentRow = document.getElementById('vehicleFitmentRow');
    if (!vehicleFitmentRow) return;

    const selectedVehicle = localStorage.getItem('activeVehicleId');

    if (!selectedVehicle) {
      vehicleFitmentRow.classList.add('no-vehicle-selected');
    } else {
      vehicleFitmentRow.classList.remove('no-vehicle-selected');
    }
  }

  updateFitmentVisibility();
  window.addEventListener('vehicle-updated', updateFitmentVisibility);
  updateVehicleState();
  window.addEventListener('vehicle-updated', updateVehicleState);

  if (mobileDropdownToggle && vehicleFitmentRow) {
    mobileDropdownToggle.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = vehicleFitmentRow.classList.toggle('show-mobile');
      mobileDropdownToggle.classList.toggle('active', isOpen);
      mobileDropdownToggle.setAttribute('aria-expanded', isOpen);
      if (!isOpen) {
        window.dispatchEvent(new Event('close-all-dropdowns'));
      }
    });
  }

  if (navHamburger && navMenu) {
    navHamburger.addEventListener('click', function (e) {
      e.preventDefault();
      navMenu.classList.toggle('active');
      document.body.classList.toggle('dropdown-open', navMenu.classList.contains('active'));
      navHamburger.classList.toggle('is-open', navMenu.classList.contains('active'));
      if (headerHamburger) {
        headerHamburger.classList.toggle('is-open', navMenu.classList.contains('active'));
      }
      syncHeaderHeight();
    });
  }

  if (vehicleSelect && wrapper) {
    vehicleSelect.addEventListener('focus', function () {
      wrapper.classList.add('open');
    });
    vehicleSelect.addEventListener('blur', function () {
      wrapper.classList.remove('open');
    });
    vehicleSelect.addEventListener('change', function () {
      wrapper.classList.remove('open');
    });
  }

  function setupDropdowns() {
    const handleNavHash = () => {
      const hash = window.location.hash;
      if (hash === '#openSizeSearch') {
        if (headerNav) headerNav.classList.remove('active');
        if (navMenu) navMenu.classList.remove('active');
        document.body.classList.remove('dropdown-open');
        if (headerHamburger) headerHamburger.classList.remove('is-open');
        if (navHamburger) navHamburger.classList.remove('is-open');
        const ui = window.uiState?.();
        if (ui) ui.openSizeSearch = true;
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } else if (hash === '#changeVehicle') {
        if (headerNav) headerNav.classList.remove('active');
        if (navMenu) navMenu.classList.remove('active');
        document.body.classList.remove('dropdown-open');
        if (headerHamburger) headerHamburger.classList.remove('is-open');
        if (navHamburger) navHamburger.classList.remove('is-open');
        window.vehicleSearch?.()?.openVehicleSearch?.();
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    };

    window.addEventListener('hashchange', handleNavHash);
    window.addEventListener('vue-ready', handleNavHash, { once: true });

    if (window.innerWidth < 768) {
      document.querySelectorAll('.nav-item.has-dropdown').forEach((item) => {
        item.addEventListener('click', function (e) {
          const dropdownLink = e.target.closest('.dropdown-menu a');
          if (dropdownLink) {
            return;
          }

          const topLink = e.target.closest('.nav-link');
          if (!topLink) {
            return;
          }

          const href = topLink.getAttribute('href') || '';
          const shouldOnlyToggle = href === '#' || href === '';
          const isAlreadyOpen = this.classList.contains('active');

          if (!shouldOnlyToggle && isAlreadyOpen) {
            return;
          }

          e.preventDefault();
          e.stopPropagation();
          document.querySelectorAll('.nav-item.has-dropdown').forEach((otherItem) => {
            if (otherItem !== this) {
              otherItem.classList.remove('active');
            }
          });
          this.classList.toggle('active');
        });
      });

      document.addEventListener('click', function (e) {
        if (!e.target.closest('.nav-item')) {
          document.querySelectorAll('.nav-item').forEach((item) => {
            item.classList.remove('active');
          });
        }
      });
    }
  }

  setupDropdowns();

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 768) {
      if (headerNav) headerNav.classList.remove('active');
      if (navMenu) navMenu.classList.remove('active');
      if (vehicleFitmentRow) vehicleFitmentRow.classList.remove('show-mobile');
      if (mobileDropdownToggle) {
        mobileDropdownToggle.classList.remove('active');
        mobileDropdownToggle.setAttribute('aria-expanded', 'false');
      }
      document.querySelectorAll('.nav-item').forEach((item) => {
        item.classList.remove('active');
      });
      document.body.classList.remove('dropdown-open');
    }
  });
});
